import React, { useCallback, useEffect, useState } from "react";
import { Switch } from 'antd';


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Button from "components/CustomButtons/Button.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';

import TableStorageOperator from "components/TableStorageOperator/TableStorageOperator"

import api from "assets/services/api.js";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Pagination from '@material-ui/lab/Pagination';
import useAuth from "hooks/useAuth";
import { formatDateFilter } from "services/formatDate.js"

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  colorCard: {
    color: "#999"
  },
  floatRight: {
    float: "right"
  },
  maxwidht: {
    maxWidth: "107%"
  },
  toogleclass: {
    marginTop: "14px",
    marginBottom: "14px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50"
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)"
  },
  zindex: {
    zIndex: "0 !important"
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px"
  },
  ftsize: {
    fontSize: "12.6px!important"
  }
};


const useStyles = makeStyles(styles);


export default function TableListOperator() {

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [toogle, setToggle] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const toogler = () => {
    toogle ? setToggle(false) : setToggle(true);
  }

  const { storageId, garlicType } = useAuth();
  const [storages, setStorages] = useState([]);

  useEffect(() => {
    loadStorage();
  }, [])


  useEffect(() => {
    loadStorage();
  }, [page, startDate, endDate, toogle, garlicType])

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function loadStorage() {

    try {
      if (garlicType === true) {
        const { data } = await api.get(`/storage/admin/garlic?id_admin=${storageId}&date_init=${startDate}&date_end=${endDate}&page=${page}&validated=${toogle}&operator=true`);        setStorages(data.storage)
      } else {
        const { data } = await api.get(`/storage/admin/${storageId}?date_init=${startDate}&date_end=${endDate}&page=${page}&validated=${toogle}&garlic=${garlicType}&operator=true`);
        setStorages(data.storage);
        setTotalPages(data.totalCount);
      }

    } catch (error) {
      //alert('erro: ' + error)
    }

  };

  const [modalShow, setModalShow] = useState(false);


  const classes = useStyles();

  return (

    <GridContainer>
      <GridItem xs={12} sm={8} md={4}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>today</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data primária</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={startDate}
              onChange={date => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={8} md={4}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>event</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data secundária </p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={endDate}
              onChange={date => setEndDate(date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={8} md={4}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="info">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <div className={classes.ftsize}>
              <p className={classes.colorCard}>Clique no <b>filtro</b> abaixo para mostrar estoques validados ou não</p>
            </div>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler} />
          </CardFooter>
        </Card>
      </GridItem>
      {storages.map(storage => (
        <TableStorageOperator key={String("Table_" + storage.id)} storage={storage} loadStorage={loadStorage} toogle={toogle} />
      ))}
      <Pagination count={totalPages} page={page} onChange={handleChange} />
    </GridContainer>
  );

}
